import { render, staticRenderFns } from "./TeacherTeaser.vue?vue&type=template&id=82dac5ac&scoped=true&"
import script from "./TeacherTeaser.vue?vue&type=script&lang=js&"
export * from "./TeacherTeaser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82dac5ac",
  null
  
)

export default component.exports